module.exports = __webpack_public_path__ + "img/pilar-lopez.2e5b79d8.jpg";